import React from 'react'
import rootReducer from '../reducers'
import PropTypes from 'prop-types'
import { GlobalProvider } from 'Shared/global_context'
import configureStore from 'Shared/configure_store'
import AppDashboardLayout from './app_dashboard_layout'

const AppDashboardRoot = ({ initialState }) => {
  const state = {
    buttons: initialState.buttons,
    directories: initialState.directories,
    nextTempId: 1,
    club_logo: initialState.club_logo,
    club_premium: initialState.club_is_premium,
    club_name: initialState.club_name,
  }

  const store = configureStore(rootReducer, state, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

  return (
    <GlobalProvider store = { store }>
      <AppDashboardLayout />
    </GlobalProvider>
  )
}

AppDashboardRoot.propTypes = {
  initialState: PropTypes.any,
  directories: PropTypes.any,
}

export default AppDashboardRoot

